"use strict";
exports.__esModule = true;
exports.SearchEntity = void 0;
var types_1 = require("../../../../types");
var page_factory_1 = require("./page-factory");
exports.SearchEntity = page_factory_1.pageFactory(types_1.PageType.SEARCH, function (prismicDoc, normalizedPage, logger) { return normalizedPage; });
//# sourceMappingURL=search.js.map